module.exports = __webpack_public_path__ + "static/img/oppoReno4_5G.8bed4fe0.png";